import {DestroyRef, Injectable, Signal, computed, signal} from '@angular/core';
import {NavigationEnd, Router as NgRouter} from '@angular/router';
import {filter} from 'rxjs/operators';
import {Translatable} from 'src/app/domain/service/translator/translatable';
import {Router} from 'src/app/infrastructure/router/router';

export interface PageHeader {
  title?: Translatable;
  icon?: string;
  iconSrc?: string;
  navigation?: boolean;
}

export interface HeaderOwner {
  readonly header: Signal<PageHeader | null>;
}

@Injectable({
  providedIn: 'root',
})
export class PageHeaderService {
  public readonly isRoot = signal(false);
  public readonly header = computed(() => this.owners().map(owner => owner.header()).filter(Boolean).pop() ?? null);

  private readonly owners = signal<HeaderOwner[]>([]);
  private backTo: string | null = null;

  constructor(
    private readonly ngRouter: NgRouter,
    private readonly router: Router,
  ) {
    this.readRouteData();
    this.ngRouter.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.readRouteData());
  }

  public register(owner: HeaderOwner, destroyRef: DestroyRef): void {
    this.owners.update(owners => [...owners, owner]);
    destroyRef.onDestroy(() => this.owners.update(owners => owners.filter(registered => registered !== owner)));
  }

  public back(): void {
    if (this.backTo) {
      this.router.navigateByUrl(this.backTo);
      return;
    }

    this.router.navigateToBackOrTo('/client');
  }

  private readRouteData(): void {
    let route = this.ngRouter.routerState.snapshot.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const routesData = route.pathFromRoot.map(parent => parent.data);

    this.isRoot.set(routesData.some(data => data.customerAreaRoot === true));
    this.backTo = routesData.map(data => data.backTo).filter(Boolean).pop() ?? null;
  }
}
